import axios from "axios";

export const axiosClient = axios.create({
  baseURL:
    process.env.REACT_APP_HEROKU_API_URL || process.env.REACT_APP_DEV_API_URL,
  headers: {
    "content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const axiosPHP = axios.create({
  baseURL: "https://www.sannicolas.gob.ar/apireact/rafam",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});
